.Main {
    width: 100%;
}